/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/RolesAndAccessQuery.graphql';
import type {
	RolesAndAccessEntrypointProps,
	RolesAndAccessQueries,
} from './RolesAndAccess.entrypoint.types.tsx';

// Identity role ARIs are inlined here so the entry-point chunk does not pull in
// `RolesAndAccess.types.tsx`. Keep them in sync with `HAM_ROLE_IDS`.
const HAM_ROLE_ID_BY_TYPE = {
	HAM_ADMIN: 'ari:cloud:assets-vertical::role/ham/admin',
	HAM_USER: 'ari:cloud:assets-vertical::role/ham/user',
} as const;

const ROLE_FILTER_QUERY_PARAM = 'role';

function parseRoleFilterQueryParamValue(
	value: string | undefined,
): 'HAM_ADMIN' | 'HAM_USER' | undefined {
	switch (value) {
		case 'admin':
			return 'HAM_ADMIN';
		case 'user':
			return 'HAM_USER';
		default:
			return undefined;
	}
}

function getInitialRoleId(roleQueryParam: string | undefined): string {
	const selectedRole = parseRoleFilterQueryParamValue(roleQueryParam) ?? 'HAM_ADMIN';
	return HAM_ROLE_ID_BY_TYPE[selectedRole];
}

type RolesAndAccessEntryPointComponent = EntryPointComponent<
	RolesAndAccessQueries,
	{},
	RolesAndAccessEntrypointProps,
	{}
>;

export const rolesAndAccessEntryPoint: EntryPoint<
	RolesAndAccessEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<RolesAndAccessEntryPointComponent>(
		/* webpackChunkName: "async-itam-settings-roles-and-access" */ './RolesAndAccess.tsx',
	),
	getPreloadProps: ({ tenantContext: { cloudId }, context }: EntryPointRouteParams) => ({
		queries: {
			rolesAndAccessQuery: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					cloudId,
					verticalType: 'HAM' as const,
					roleIds: [getInitialRoleId(context.query[ROLE_FILTER_QUERY_PARAM])],
				},
			},
		},
		extraProps: {},
	}),
});
